import Verification from '@app/TicketManagement/Verification'
import ParticipantQuestionnaire from '@app/TicketManagement/ParticipantQuestionnaire'
import Check from '@app/TicketManagement/Check'
import NotFound from '@app/TicketManagement/NotFound'

export default function install(Vue, prefix = 'ticket-management-') {
  Vue.component(`${prefix}verification`, Verification)
  Vue.component(`${prefix}participant-questionnaire`, ParticipantQuestionnaire)
  Vue.component(`${prefix}check`, Check)
  Vue.component(`${prefix}not-found`, NotFound)
}
